document.addEventListener("DOMContentLoaded", function () {
    if (document.querySelector("form[name*=subscription-setup-file-request]")) {
        import(/* webpackChunkName: "ssfr" */ "/Features/SetupFileRequest/js/epiforms-events.js");
    }
});
